import React from 'react';

export const LoadingPage = ({ text = 'Loading...' }) => {
    return (
        <main className="loading-page d-flex flex-column justify-content-center align-items-center w-100 vh-100">
            <div className="rainbow-loader mb-3"></div>
            <p className="text-muted">{text}</p>
        </main>
    );
};
